import { render, staticRenderFns } from "./UseCase2.vue?vue&type=template&id=174eed79&scoped=true&"
import script from "./UseCase2.vue?vue&type=script&lang=js&"
export * from "./UseCase2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174eed79",
  null
  
)

export default component.exports